import { render } from "./Archivejob.vue?vue&type=template&id=de8b8a10&scoped=true"
import script from "./Archivejob.vue?vue&type=script&lang=js"
export * from "./Archivejob.vue?vue&type=script&lang=js"

import "./Archivejob.vue?vue&type=style&index=0&id=de8b8a10&scoped=true&lang=css"

import exportComponent from "/home/trit/trit/dev/caspwebapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de8b8a10"]])

export default __exports__